// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export { PageTreeQuickActions } from './PageTreeQuickActionsLoadable.ts';

export type InlineRenameProps = {
	children: any;
	id: string;
	title: string;
	displayEmoji: string;
	isEditingTitle: boolean;
	setIsEditingTitleId: (isEditingTitleId: string | null) => Promise<void>;
	updateContentTreeItem: (id: string, data: object) => void;
	isNewContent?: boolean;
	setFocusedQuickActionsId: (focusedQuickActionsId: string | null) => void;
	contentStatus?: string;
	contentType?: string;
	indent?: number;
	isLive?: boolean;
};

export const InlineRename: LoadableType<Omit<InlineRenameProps, 'flags'>> = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-InlineRename" */ './InlineRename.tsx'))
			.InlineRename,
	loading: ({ children }) => children,
});

// eslint-disable-next-line import/no-cycle
export { ConditionalInlineRename } from './ConditionalInlineRename.tsx';
